module.exports = __webpack_public_path__ + "img/icon-libros.6251a3d1.svg";